<template>
    <form-item-wrapper :widget="widget" :formData="formData" :isDesign="isDesign" ref="itemref">
        <a-upload v-model:fileList="datas.fileList" :name="widget.options.name"
            :showUploadList="widget.options.showUploadList" :customRequest="customRequest" :action="widget.options.action"
            :maxCount="widget.options.maxCount" :accept="widget.options.accept" :disabled="widget.options.disabled"
            list-type="picture-card" :class="{ 'ant-upload-hidden': datas.fileList.length >= widget.options.maxCount }">
            <div>
                <plus-outlined />
                <div style="margin-top: 8px">Upload</div>
            </div>
            <template #itemRender="{ file, actions }">
                <div class="echowrap">
                    <div class="loadingecho" v-if="file.status == 'uploading'">
                        <a-progress :percent="datas.percent" status="active" :show-info="false" />
                        <span>{{ datas.percent + '%' }}</span>
                    </div>
                    <div class="errorecho" v-else-if="file.status == 'error'">
                        error
                    </div>
                    <template v-else>
                        <div class="echoimage">
                            <img :src="file.thumbUrl" />
                            <div v-if="file.type.indexOf('image') == -1" class="namespan">{{ file.name }}</div>
                        </div>
                        <div class="echobtn">
                            <eye-outlined v-if="file.type.indexOf('image') != -1" @click="handlePreview(file)" />
                            <download-outlined @click="actions.download" />
                            <delete-outlined v-if="!widget.options.disabled" @click="handleRemove(file)" />
                        </div>
                    </template>
                </div>
            </template>
        </a-upload>
        <a-modal :visible="datas.previewVisible" :title="datas.previewTitle" :footer="null" @cancel="handleCancel">
            <img alt="example" style="width: 100%" :src="datas.previewImage" />
        </a-modal>
    </form-item-wrapper>
</template>

<script setup>
import FormItemWrapper from "./form-item-wrapper.vue";
import { ref, toRefs, onMounted, reactive } from 'vue';
import useEvent from "./useEvent";
import http from "@/request/request";
import { message } from 'ant-design-vue';

const props = defineProps({
    widget: Object,
    formData: Object,
    isDesign: Boolean,
})
const { widget, formData, isDesign } = toRefs(props)
const itemref = ref(null);
const datas = reactive({
    fileList: [],
    previewVisible: false,
    previewImage: '',
    previewTitle: '',
    percent: 0,
});

const handleCancel = () => {
    datas.previewVisible = false;
};
const handlePreview = (file) => {
    datas.previewVisible = true;
    datas.previewImage = file.thumbUrl;
    datas.previewTitle = file.name || file.url.substring(file.url.lastIndexOf('/') + 1);
};
const handleRemove = (file) => {
    const fileUid = file.uid;
    const fileIndex = datas.fileList.findIndex(
        (fileItem) => fileItem.uid == fileUid
    );
    datas.fileList.splice(fileIndex, 1);
    formData.value[widget.value.name] = datas.fileList.map(item => item.fileId).join(",")
};
// 自定义上传方法
const customRequest = (e) => {
    datas.percent = 0
    const file = e.file;
    const fileUid = file.uid;
    const fileIndex = datas.fileList.findIndex(
        (fileItem) => fileItem.uid == fileUid
    );

    const fileType = file.type;
    if (widget.value.options.accept == "image/*") {
        if (fileType.indexOf("image") < 0) {
            message.error(`上传文件类型有误！`);
            datas.fileList.splice(fileIndex, 1);
            return false;
        }
    }

    if (file.size > widget.value.options.maxFileSize * 1024 * 1024) {
        message.error(
            `文件大小超出${widget.value.options.maxFileSize}M！`
        );
        datas.fileList.splice(fileIndex, 1);
        return false;
    }

    if (!!widget.value.options.action) return false;

    let fileData = new FormData();
    fileData.append("appId", "A011010120221009001");
    fileData.append("category", "category");
    fileData.append("waterRemark", widget.value.options.waterRemark);
    fileData.append("files", file);
    const config = {
        url: "/fileServer/v1/file-manage/upload",
        data: fileData,
        method: 'post',
        timeout: 60 * 1000,
        transformRequest: [function (data, headers) {
            // 去除post请求默认的Content-Type
            delete headers['Content-Type']
            return data
        }],
        onUploadProgress: ({ total, loaded }) => {
            const percent = Math.round((loaded / total) * 100).toFixed(0) * 1;
            datas.percent = percent
            e.onProgress({ percent });
        }
    }
    http.request(config).then(res => {
        if (res.data.code == 200) {
            const token = sessionStorage.getItem("USER_TOKEN");
            if (res.data.rows && res.data.rows.length > 0) {
                res.data.rows.forEach(fileId => {
                    let thumbUrl = ''
                    if (fileType.indexOf("image") != -1) {
                        thumbUrl = `/fileServer/v1/file-manage/downloadV2/${fileId}?access-token=${token}`
                    } else {
                        thumbUrl = require('@/assets/logo.png')
                    }
                    file.fileId = fileId
                    file.uid = fileId
                    file.url = `/fileServer/v1/file-manage/downloadV2/${fileId}?access-token=${token}`;
                    file.thumbUrl = thumbUrl
                    datas.fileList.splice(fileIndex, 1, file);
                });
                formData.value[widget.value.name] = datas.fileList.map(item => item.fileId).join(",")
            }
            e.onSuccess(res.data, e);
            message.success("上传成功");
        } else if (res.data.msg) {
            e.onError();
            datas.fileList.splice(fileIndex, 1);
            message.error(res.msg);
        }
    }).catch(err => {
        e.onError();
        datas.fileList.splice(fileIndex, 1);
        message.error("上传失败," + err);
    })
}

const loadFiles = () => {
    if (!isDesign.value && typeof formData.value[widget.value.name] == "string") {
        let fileIdList = formData.value[widget.value.name].split(",").filter(item => !!item)
        if (fileIdList.length == 0) return
        const config = {
            url: "/fileServer/v1/file-manage/queryFileInfoMap",
            method: "post",
            data: { fileIdList },
        }
        http.request(config).then(res => {
            if (res.data.code == 200) {
                const token = sessionStorage.getItem("USER_TOKEN");
                datas.fileList = fileIdList.map(item => {
                    let thumbUrl = ''
                    let type = ''
                    if (['.jpeg', '.jpg', '.svg', '.png', '.webp', '.gif'].indexOf(res.data.data[item].fileExt.toLowerCase()) != -1) {
                        type = "image"
                        thumbUrl = `/fileServer/v1/file-manage/downloadV2/${item}?access-token=${token}`
                    } else {
                        thumbUrl = require('@/assets/logo.png')
                    }
                    return {
                        fileId: item,
                        type,
                        uid: item,
                        name: res.data.data[item].fileName,
                        status: 'done',
                        url: `/fileServer/v1/file-manage/downloadV2/${item}?access-token=${token}`,
                        thumbUrl,
                    }
                });
            } else if (res.data.msg) {
                message.error(res.data.msg);
            }
        }).catch(err => message.error("请求失败," + err))
    }
}

onMounted(() => loadFiles())

const {
    handleOnChange,
} = useEvent(widget.value, itemref, formData.value);
</script>

<style lang="scss" scoped>
::v-deep .ant-upload-hidden .ant-upload-select-picture-card {
    width: 0;
    overflow: hidden;
    border: none;
}

.echowrap {
    width: 104px;
    height: 104px;
    text-align: center;
    vertical-align: top;
    background-color: #fafafa;
    border: 1px dashed #d9d9d9;
    border-radius: 2px;
    position: relative;

    .echoimage:before {
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        background-color: #00000080;
        opacity: 0;
        transition: all .3s;
        content: " ";
    }

    .echoimage {
        width: 100%;
        height: 100%;
        position: absolute;
        display: flex;
        flex-direction: column;

        img {
            flex: 1;
            height: 0;
        }

        .namespan {
            padding: 0 5px;
            z-index: 2;
            width: 100%;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap; //溢出不换行
        }

        .namespan:hover {
            overflow: visible;
        }
    }

    .echobtn {
        display: none;
        z-index: 2;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #ffffff;
        width: max-content;

        span {
            margin: 4px;
        }
    }

    .loadingecho,
    .errorecho {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        padding: 5px;
        transform: translate(-50%, -50%);
    }

    .errorecho {
        color: red;
    }
}

.echowrap:hover {
    .echoimage:before {
        opacity: 0.7;
    }

    .echobtn {
        display: block;
    }
}
</style>